module.exports = __webpack_public_path__ + "img/preciousMetals.eb69f8a.jpg";